import { Department, USER_DEPARTMENT } from './department.enum';

export const ACADEMIC_AFFAIRS_ROLES = [
  'Dean',
  'Associate Dean',
  'Department Chair',
  'Professor',
  'Lecturer/Instructor',
  'Adjunct Faculty',
  'Academic Advisor',
  'Other',
];

export const INSTITUTIONAL_ADVANCEMENT_AND_DEVELOPMENT_ROLES = [
  'Vice President for Advancement',
  'Development Officer',
  'Alumni Relations Director',
  'Communications Director',
  'Other',
];

export const ATHLETICS_DEPARTMENT_ROLES = [
  'Athletic Director',
  'Coach',
  'Athletic Trainer',
  'Other',
];

export const AUXILIARY_SERVICES_ROLES = [
  'Director of Dining Services',
  'Bookstore Manager',
  'Health Services Director',
  'Transportation and Parking Manager',
  'Other',
];

export const CONTINUING_EDUCATION_ROLES = [
  'Director of Continuing Education',
  'Program Coordinator',
  'Instructor',
  'Other',
];

export const DIVERSITY_AND_INCLUSION_ROLES = [
  'Chief Diversity Officer',
  'Diversity Program Coordinator',
  'Other',
];

export const ENROLLMENT_MANAGEMENT_ROLES = [
  'Director of Admissions',
  'Director of Financial Aid',
  'University Registrar',
  'Other',
];

export const EXECUTIVE_LEADERSHIP_ROLES = [
  'President',
  'Provost',
  'Vice President',
  'Other',
];

export const FINANCE_AND_ADMINISTRATION_ROLES = [
  'Chief Financial Officer (CFO)',
  'Human Resources Director',
  'Facilities Manager',
  'Controller',
  'Purchasing Manager',
  'Other',
];

export const INFORMATION_TECHNOLOGY_SERVICES_ROLES = [
  'Chief Information Officer (CIO)',
  'IT Manager',
  'Network Administrator',
  'Help Desk Support',
  'Other',
];

export const LEGAL_AFFAIRS_ROLES = [
  'General Counsel',
  'Legal Assistant',
  'Other',
];

export const MARKETING_AND_COMMUNICATIONS_ROLES = [
  'Chief Communications Officer',
  'Marketing Manager',
  'Public Relations Specialist',
  'Social Media Coordinator',
  'Other',
];

export const PUBLIC_SAFETY_ROLES = [
  'Director of Public Safety',
  'Campus Police Officer',
  'Security Officer',
  'Other',
];

export const RESEARCH_ROLES = [
  'Vice President for Research',
  'Director of Sponsored Programs',
  'Research Compliance Officer',
  'Laboratory Manager',
  'Other',
];

export const STUDENT_AFFAIRS_ROLES = [
  'Vice President for Student Affairs',
  'Dean of Students',
  'Director of Housing and Residence Life',
  'Director of Career Services',
  'Counselor',
  'Student Activities Coordinator',
  'Other',
];

export const UNIVERSITY_LIBRARIES_ROLES = [
  'University Librarian',
  'Librarian',
  'Library Assistant',
  'Other',
];

export type UserDepartmentRole =
  | typeof ACADEMIC_AFFAIRS_ROLES[number]
  | typeof INSTITUTIONAL_ADVANCEMENT_AND_DEVELOPMENT_ROLES[number]
  | typeof ATHLETICS_DEPARTMENT_ROLES[number]
  | typeof AUXILIARY_SERVICES_ROLES[number]
  | typeof CONTINUING_EDUCATION_ROLES[number]
  | typeof DIVERSITY_AND_INCLUSION_ROLES[number]
  | typeof ENROLLMENT_MANAGEMENT_ROLES[number]
  | typeof EXECUTIVE_LEADERSHIP_ROLES[number]
  | typeof FINANCE_AND_ADMINISTRATION_ROLES[number]
  | typeof INFORMATION_TECHNOLOGY_SERVICES_ROLES[number]
  | typeof LEGAL_AFFAIRS_ROLES[number]
  | typeof MARKETING_AND_COMMUNICATIONS_ROLES[number]
  | typeof PUBLIC_SAFETY_ROLES[number]
  | typeof RESEARCH_ROLES[number]
  | typeof STUDENT_AFFAIRS_ROLES[number]
  | typeof UNIVERSITY_LIBRARIES_ROLES[number];

export const USER_DEPARTMENT_ROLES_MAP = {
  [USER_DEPARTMENT[Department['Academic Affairs']]]: ACADEMIC_AFFAIRS_ROLES,
  [USER_DEPARTMENT[
    Department['Institutional Advancement and Development']
  ]]: INSTITUTIONAL_ADVANCEMENT_AND_DEVELOPMENT_ROLES,
  [USER_DEPARTMENT[
    Department['Athletics Department']
  ]]: ATHLETICS_DEPARTMENT_ROLES,
  [USER_DEPARTMENT[Department['Auxiliary Services']]]: AUXILIARY_SERVICES_ROLES,
  [USER_DEPARTMENT[
    Department['Continuing Education']
  ]]: CONTINUING_EDUCATION_ROLES,
  [USER_DEPARTMENT[
    Department['Diversity and Inclusion']
  ]]: DIVERSITY_AND_INCLUSION_ROLES,
  [USER_DEPARTMENT[
    Department['Enrollment Management']
  ]]: ENROLLMENT_MANAGEMENT_ROLES,
  [USER_DEPARTMENT[
    Department['Executive Leadership']
  ]]: EXECUTIVE_LEADERSHIP_ROLES,
  [USER_DEPARTMENT[
    Department['Finance and Administration']
  ]]: FINANCE_AND_ADMINISTRATION_ROLES,
  [USER_DEPARTMENT[
    Department['Information Technology Services']
  ]]: INFORMATION_TECHNOLOGY_SERVICES_ROLES,
  [USER_DEPARTMENT[Department['Legal Affairs']]]: LEGAL_AFFAIRS_ROLES,
  [USER_DEPARTMENT[
    Department['Marketing and Communications']
  ]]: MARKETING_AND_COMMUNICATIONS_ROLES,
  [USER_DEPARTMENT[Department['Public Safety']]]: PUBLIC_SAFETY_ROLES,
  [USER_DEPARTMENT[Department.Research]]: RESEARCH_ROLES,
  [USER_DEPARTMENT[Department['Student Affairs']]]: STUDENT_AFFAIRS_ROLES,
  [USER_DEPARTMENT[
    Department['University Libraries']
  ]]: UNIVERSITY_LIBRARIES_ROLES,
};
